(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/local-storage/assets/javascripts/local-storage-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-data/local-storage/assets/javascripts/local-storage-actions.js');
"use strict";

const _excluded = ["CreateGame"],
  _excluded2 = ["loadingGame", "isLoading"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const Storage = svs.components.Storage;
const LOAD_FROM_LOCAL_STORAGE = 'LOAD_FROM_LOCAL_STORAGE';
const _svs$components$marke = svs.components.marketplaceData.localStorage.constants,
  LOCAL_STORAGE_NAME = _svs$components$marke.LOCAL_STORAGE_NAME,
  LOCAL_STORAGE_DOMAIN = _svs$components$marke.LOCAL_STORAGE_DOMAIN;
const loadFromLocalStorage = () => dispatch => {
  const data = Storage.browser.get(LOCAL_STORAGE_NAME, LOCAL_STORAGE_DOMAIN);
  if (data) {
    const CreateGame = data.CreateGame,
      restData = _objectWithoutProperties(data, _excluded);
    const _ref = CreateGame || {},
      loadingGame = _ref.loadingGame,
      isLoading = _ref.isLoading,
      restCreateGame = _objectWithoutProperties(_ref, _excluded2);
    dispatch({
      type: LOAD_FROM_LOCAL_STORAGE,
      payload: _objectSpread(_objectSpread({}, restData), {}, {
        CreateGame: _objectSpread({}, restCreateGame)
      })
    });
  }
};
const clearFromLocalStorage = () => () => {
  Storage.browser.set(LOCAL_STORAGE_NAME, LOCAL_STORAGE_DOMAIN, undefined);
};
setGlobal('svs.components.marketplaceData.localStorage.actions', {
  loadFromLocalStorage,
  LOAD_FROM_LOCAL_STORAGE,
  clearFromLocalStorage
});

 })(window);